import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  private isDark = signal(false);

  isDarkTheme = computed(() => this.isDark());

  toggleTheme() {
    const html = document.documentElement;
    const currentDark = html.classList.contains('dark');

    if (currentDark) {
      html.classList.remove('dark');
      localStorage.setItem('theme', 'light');
      this.isDark.set(false);
    } else {
      html.classList.add('dark');
      localStorage.setItem('theme', 'dark');
      this.isDark.set(true);
    }
  }

  initTheme() {
    const saved = localStorage.getItem('theme');
    const isDark = saved === 'dark';

    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    this.isDark.set(isDark);
  }
}
